import { authActions, selectUserLoginDetail, selectUserLoginLoading } from "../../store/auth/authSlice";
import { useAppDispatch, useAppSelector } from "../../store/hook";
import { useCallback } from "react";

const useAuth = () => {
    const dispatch = useAppDispatch();
    return {
        login: useCallback((payload) => {
            dispatch(authActions.loginDispatch(payload));
        }, [dispatch]),
        getUserDetail: useCallback((payload) => {
            dispatch(authActions.fetchUserDetail(payload));
        }, [dispatch]),
        
        auth: useAppSelector(selectUserLoginLoading),
        detail: useAppSelector(selectUserLoginDetail)
    };
};

export default useAuth;
